import { render, staticRenderFns } from "./ActivateOtherSupplier.vue?vue&type=template&id=6cdf5010&scoped=true"
import script from "./ActivateOtherSupplier.vue?vue&type=script&lang=js"
export * from "./ActivateOtherSupplier.vue?vue&type=script&lang=js"
import style0 from "./ActivateOtherSupplier.vue?vue&type=style&index=0&id=6cdf5010&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cdf5010",
  null
  
)

export default component.exports